var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90 78C85.2175 78 80.955 80.2525 78.205 83.75L41.075 65.185C41.6725 63.5675 42 61.8225 42 60C42 58.1775 41.6725 56.4325 41.075 54.815L78.3375 36.185C81.085 39.72 85.37 42 90.1825 42C98.4525 42 105.183 35.27 105.183 27C105.183 18.73 98.4525 12 90.1825 12C81.9125 12 75.1825 18.73 75.1825 27C75.1825 28.315 75.355 29.5925 75.675 30.81L37.89 49.7025C35.155 46.81 31.285 45.0025 27 45.0025C18.73 45.0025 12 51.7325 12 60.0025C12 68.2725 18.73 75.0025 27 75.0025C31.285 75.0025 35.155 73.1925 37.89 70.3025L75.515 89.115C75.1825 90.355 75 91.66 75 93.005C75 101.275 81.73 108.005 90 108.005C98.27 108.005 105 101.275 105 93.005C105 84.735 98.27 78.005 90 78.005V78ZM90.1825 18C95.145 18 99.1825 22.0375 99.1825 27C99.1825 31.9625 95.145 36 90.1825 36C85.22 36 81.1825 31.9625 81.1825 27C81.1825 22.0375 85.22 18 90.1825 18ZM27 69C22.0375 69 18 64.9625 18 60C18 55.0375 22.0375 51 27 51C31.9625 51 36 55.0375 36 60C36 64.9625 31.9625 69 27 69ZM90 102C85.0375 102 81 97.9625 81 93C81 88.0375 85.0375 84 90 84C94.9625 84 99 88.0375 99 93C99 97.9625 94.9625 102 90 102Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.22198d76.svg";
export { ForwardRef as ReactComponent };